<template lang="html">
  <div
    class="flex flex-nowrap middle-xs sandbox-navbar"
    style="padding: 0px 30px;"
  >
    <div class="col-xs-1 row clickable" style="padding: 0 0 0 20px; margin: 0;">
      <img
        src="/static/logos/parlay_logo_3.svg"
        style="width: 40px; height: 48px;"
      />
    </div>
    <div class="center-xs flex-grow italics pl-body-1">
      <pl-button
        @click.native="openParlayUrl"
        class="pl-secondary-font"
        style="font-weight: bold;"
      >
        <span class="demo-title"
          >This is a Parlay Online Interactive Demo:</span
        >
        <span>Learn More</span>
      </pl-button>
    </div>
    <div class="flex flex-nowrap end-xs col-xs-1">
      <template v-if="!getIsAuthenticated">
        <pl-button
          @click.native="$router.push('/account/login')"
          class="pl-white-font pl-primary"
          style="border: white 1px solid; box-shadow: none;"
        >
          sign in
        </pl-button>
        <pl-button
          @click.native="$router.push('/account/signup')"
          class="pl-white-font pl-primary"
          style="border: white 1px solid; box-shadow: none;"
        >
          sign up
        </pl-button>
      </template>
      <div v-else>
        <pl-button
          @click.native="$router.push('/')"
          class="pl-white-font pl-primary"
          style="border: white 1px solid; box-shadow: none;"
        >
          View My Dashboard
        </pl-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        parlay_info_url: 'https://parlayideas.com/book-demo/',
      };
    },
    computed: {
      ...mapGetters(['getIsAuthenticated']),
    },
    methods: {
      openParlayUrl() {
        window.open(this.parlay_info_url, '_blank');
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

  .sandbox-navbar
    background-color: pl-primary;

  .dark-blue
    color: pl-secondary

  .charcoal
    color: pl-charcoal

  .demo-title
    display: inline

  @media (max-width: 800px)
    .demo-title
      display: none
</style>



// WEBPACK FOOTER //
// onlineWalkthrough.navbar.vue?ded2ba5c